import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility for constructing className strings conditionally.
 * Combines clsx for conditional classes with tailwind-merge
 * to resolve conflicting Tailwind utility classes.
 *
 * Example: cn('bg-white', 'bg-black') → 'bg-black' (last wins)
 * Without twMerge, both classes would remain causing CSS specificity issues.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export default cn;
